<template>
<div class="yk-multiselect--content-main">
  <el-form class="yk-multiselect yk-multiselect-s-wrapper" label-width="70px">
        <el-form-item label="题目：">
            <div>
              <el-input placeholder="请输入题干" v-model="li.ContentText" class="yk-que-input-main" :disabled="isShow" v-if="!isShow" />
              <p v-if="isShow">{{li.ContentText}}</p>
            </div>
        </el-form-item>
        <el-form-item label="选项：">
          <el-form-item label-width="30px" v-for="(question,index) in li.dataJson" :key="index">
            <!-- <el-radio-group> -->
              <span :label="index">{{alphabet[index]}}:
                <el-input placeholder="请输入选项内容" v-model="question.Content" :disabled="isShow" v-if="!isShow" />
                <p v-if="isShow" class="p-content-text">{{question.Content}}</p>
                <i class="el-icon-delete" @click="closeChoice(index)" style="margin-left: 17px;font-size: 18px;" v-show="!isShow"></i>
              </span>
            <!-- </el-radio-group> -->
          </el-form-item>
        </el-form-item>
        <div class="yk-que-add-btn-wrapper">
            <el-button  class="yk-que-add-btn-s" size="small" type="primary" icon="el-icon-circle-plus" @click="addChoice" v-show="!isShow">添加选项</el-button>
        </div>
      
        <!-- <el-button type="primary" v-show="isquestion" @click='save()'>保存</el-button> -->
  </el-form>
</div>
</template>

<script>
import { addQuestionnaireQuestion } from "api/v1.faceteach.questionnaire";
import { addQuestion } from "api/v1.design.coursequestionnaire";
export default {
  name: "h-h",
  components: {
    // tuiEditor
  },
  props: {
    queTitle: {
      type: String,
      default: ""
    },
    queFaceId: {
      type: String,
      default: ""
    },
    questionnaireId: {
      type: String,
      default: ""
    },
    queId: {
      type: String,
      default: ""
    },
    quesType: {
      type: Number,
      default: 1
    },
    quesOrder: {
      type: Number,
      default: 1
    },
    isquestion: {
      type: Boolean,
      default: true
    },
    courseId: {
      type: String,
      default: ""
    },
    iSubmit: {
      type: Boolean,
      default: false
    },
    li: {
      type: Object,
      default: {
        questionId: "",
        ContentText: "",
        dataJson: [
          {
            Content: ""
          },
          {
            Content: ""
          },
          {
            Content: ""
          },
          {
            Content: ""
          }
        ],
        questionType: 1,
        sortOrder: 1
      }
    },
    questionIndex: {
      type: Number,
      default: 999
    },
  },
  created() {
    this.thisContent = this.queTitle;
  },
  data() {
    return {
      content: "请输入内容",
      alphabet: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ],
      thisContent: "",
      isShow:false,
    };
  },
  watch: {
    iSubmit: function(val) {
      if (val) {
        //this.saveQuestion(1);
        this.checkSubmit();
      }
    },
    queTitle: function(val) {
      this.thisContent = this.queTitle;
    },
  },
  methods: {
    // 添加选项
    addChoice: function() {
      var n = this.li.dataJson.length;
      if (n >= 26) {
        this.$message("您最多可添加26个选项哦");
        return;
      }
      var str = {
        Content: ""
      };
      this.li.dataJson.push(str);
    },
    // 删除选项
    closeChoice: function(index) {
      // for (var i = index+1; i <= this.dataJson.length-1; i++) {
      //   this.dataJson[i].SortOrder = this.dataJson[i].SortOrder -1;
      // }
      this.li.dataJson.splice(index, 1);
    },
    checkSubmit: function() {
      if (this.li.ContentText == "") {
        this.$emit("submit", {
          code: 0,
          count: 1,
          msg: "第" + this.li.sortOrder + "题标题为空"
        });
        return;
      }
      let right = true;
      for (let i = 0; i < this.li.dataJson.length; i++) {
        if (this.li.dataJson[i].Content == "") {
          this.$emit("submit", {
            code: 0,
            count: 1,
            msg: "第" + this.li.sortOrder + "题选项为空"
          });
          right = false;
          break;
        }
      }
      if (right) {
        this.$emit("submit", { code: 1, count: 1, msg: "success" });
      }
    },
    saveQuestion: function(type) {
      //type 1 由父页面发送指令统一提交保存
      //type 2 由子页面独立提交保存
      let title = this.queTitle;
      let stringJson = JSON.stringify(this.dataJson);
      let activityId = this.queFaceId;
      let questionnaireId = this.questionnaireId;
      let questionId = this.queId;
      let quesType = this.quesType;
      addQuestionnaireQuestion(
        activityId,
        questionnaireId,
        questionId,
        title,
        stringJson,
        "",
        quesType,
        this.quesOrder
      ).then(rst => {
        if (rst.code > 0) {
          //独立提交时，触发父页面刷新事件；统一提交时，触发done事件：统计成功个数
          if (type == 1) {
            this.$emit("done", { code: 1 });
          } else {
            this.$emit("updatePage", {});
          }
        } else {
          this.$message(rst.msg);
        }
      });
    },
    saveQuestionSingle: function() {
      //每一小题独立提交保存
      let title = this.queTitle;
      let stringJson = JSON.stringify(this.dataJson);
      let activityId = this.queFaceId;
      let questionnaireId = this.questionnaireId;
      let questionId = this.queId;
      let quesType = this.quesType;
      addQuestion(
        this.courseId,
        questionnaireId,
        questionId,
        title,
        stringJson,
        "",
        quesType
      ).then(rst => {
        if (rst.code > 0) {
          this.$emit("updatePage", {});
        }
        this.$message(rst.msg);
      });
    },
    save: function() {
      if (this.queFaceId == "" || this.queFaceId == null) {
        this.saveQuestionSingle();
      } else {
        this.saveQuestion(2);
      }
    }
  },
  mounted(){
    let path=this.$route.path;
    if(path.indexOf('ShareSurveyCourseView')!=-1){
        this.isShow=true;
    }
  }

};
</script>

<style lang="scss">
.dark{
  .yk-multiselect--content-main {
    .yk-multiselect-s-wrapper {
      .el-form-item {
        .el-form-item__label {
          color: #fff;
          font-size: 16px;
        }
        .yk-que-input-main {
          width: calc(100% - 40px);
        }
      }
      .yk-que-add-btn-wrapper {
        text-align: right;
        .yk-que-add-btn-s {
          .el-icon-circle-plus {
            color: #fff;
          }
        }
      }
    }
    .yk-multiselect {
      .el-form-item .el-form-item {
        margin-bottom: 20px;
      }
      .el-input {
        width: calc(100% - 90px);
        margin-left: 15px;

        .el-input__inner {
          background-color: #374256;
          color: #fff;
          border: none;
          font-size: 16px;
        }
      }
      i.el-icon-close {
        font-size: 15px;
        margin-left: 10px;
      }
      .el-col .yk-addChoice {
        margin-left: 70px;
        color: #606266;
      }
    }
  }
}
.light{
  .yk-multiselect--content-main {
  .yk-multiselect-s-wrapper {
    .el-form-item {
      .el-form-item__label {
        color: #333;
        font-size: 16px;
      }
      .yk-que-input-main {
        width: calc(100% - 40px);
      }
    }
    .yk-que-add-btn-wrapper {
      text-align: right;
      .yk-que-add-btn-s {
        .el-icon-circle-plus {
          color: #fff;
        }
      }
    }
  }
  .yk-multiselect {
    .el-form-item .el-form-item {
      margin-bottom: 20px;
    }
    .el-input {
      width: calc(100% - 90px);
      margin-left: 15px;

      .el-input__inner {
        background-color: #fff;
        color: #333;
        border: none;
        font-size: 16px;
      }
    }
    i.el-icon-close {
      font-size: 15px;
      margin-left: 10px;
    }
    .el-col .yk-addChoice {
      margin-left: 70px;
      color: #606266;
    }
  }
  }
  .p-content-text{
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 100px);
    color: #606266;
  }
}
</style>

